// assets
import { IconHelp, IconSettings } from '@tabler/icons';

// constant
const icons = { IconHelp, IconSettings };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
    id: 'sample-docs-roadmap',
    type: 'group',
    children: [
        {
            id: 'documentation',
            title: 'Documentation',
            type: 'item',
            url: '/documentation',
            icon: icons.IconHelp,
            breadcrumbs: false
        }
    ]
};

export default other;
